import { fetchImportPreviewStatus } from 'features/importerv2/importer-api'

/** Maximum polling attempts before surfacing a timeout error. */
const MAX_POLL_ATTEMPTS = 120

/** Milliseconds between status polls. */
const POLL_INTERVAL_MS = 1500

/**
 * Poll `fetchImportPreviewStatus` until `.status === 'idle'` or the attempt
 * cap is reached.
 *
 * Used by MapColumnsStep (after createImportPreview) and ReviewImportStep
 * (after performSetCompanies / performSetContacts) to wait for Celery task
 * completion before reading prepared data or advancing the wizard.
 *
 * @throws Error when the cap is exceeded or the underlying fetch throws.
 */
export async function pollUntilIdle(importNumber: number): Promise<void> {
  for (let attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt++) {
    // Check first — a fast task may already be idle, so we don't waste the
    // first interval sleeping. Only wait between subsequent polls.
    const status = await fetchImportPreviewStatus(importNumber)
    if (status.status === 'idle') return
    await new Promise<void>((resolve) => setTimeout(resolve, POLL_INTERVAL_MS))
  }
  throw new Error(
    'Import is taking longer than expected. Please refresh and check the status.'
  )
}
